import { createRouter, createWebHistory } from "vue-router";
import TabBottom from "../layout/TabBottom.vue";

const routes = [
  {
    path: "/",
    name: "标签页",
    component: TabBottom,
    children: [
      {
        path: "",
        component: () => import("../views/Home.vue")
      },
      {
        path: "person",
        component: () => import("../views/Person.vue")
      }
    ]
  },
  {
    path: "/orderMinute",
    name: "OrderMinute",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/OrderMinute.vue")
  },
  {
    path: "/Login",
    name: "Login",
    component: () => import("../views/Login/Login.vue")
  },
  {
    path: "/addTrainSpecies",
    name: "AddTrainSpecies",
    component: () => import("../views/Admin/AddTrainSpecies.vue")
  },
  {
    path: "/addTrainProject",
    name: "addTrainProject",
    component: () => import("../views/Admin/AddTrainProject.vue")
  },
  {
    path: "/addTrainCourse",
    name: "addTrainCourse",
    component: () => import("../views/Admin/AddTrainCourse.vue")
  },
  {
    path: "/paid",
    name: "paid",
    component: () => import("../views/PaidPage.vue")
  },
  {
    path: "/chooseWork",
    name: "chooseWork",
    component: () => import("../views/Admin/ChooseWork.vue")
  },
  {
    path: "/seeRegister",
    name: "seeRegister",
    component: () => import("../views/Admin/SeeRegisterInformation.vue")
  },
  {
    path: "/registerMinute",
    name: "registerMinute",
    component: () => import("../views/Admin/RegistMinute.vue")
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
